// extracted by mini-css-extract-plugin
export var label = "_ir-2";
export var slideContainer = "_ir-0";
export var slider = "_ir-1";